// extracted by mini-css-extract-plugin
export default {"cls1":"SocialActionsMenu-cls1__PS","cls2":"SocialActionsMenu-cls2_KAr SocialActionsMenu-cls1__PS"};